import React, { PropTypes } from "react";
import BrandContainer from "./Brands/BrandContainer";
import withMatchingBrands from "../Base/withMatchingBrands";
import "./CarSeatsContainer.css";

const CarSeatsContainer = ({ additionalInfo, display, gender, isAffixed, matchingBrands }) => {
  if(display) {
    return(
      <div className="car-seats available-sizes-container container">
        <p>
          <i>{additionalInfo}</i>
        </p>
        {
          matchingBrands
            .map(
              (brand, index) => <BrandContainer key={index} brand={brand} gender={gender} isAffixed={isAffixed}/>
            )
        }
      </div>
    );
  }
  return null;
};

CarSeatsContainer.propTypes = {
  additionalInfo: PropTypes.number,
  display: PropTypes.bool.isRequired,
  gender: PropTypes.string.isRequired,
  isAffixed: PropTypes.bool.isRequired,
  matchingBrands: PropTypes.array.isRequired,
};

export default withMatchingBrands(CarSeatsContainer);



/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/CarSeatsContainer.js
 **/